import { render, staticRenderFns } from "./SellingPointWithText.vue?vue&type=template&id=1199dbf2&scoped=true&"
import script from "./SellingPointWithText.vue?vue&type=script&lang=js&"
export * from "./SellingPointWithText.vue?vue&type=script&lang=js&"
import style0 from "./SellingPointWithText.vue?vue&type=style&index=0&id=1199dbf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1199dbf2",
  null
  
)

export default component.exports